/*
 * Main desk js file
 */

// newTool right slideout
$(function () {

    $('body').tooltip({
        selector: '[title]:not(".mceMenuItem span.mceText")',
        container: 'body',
        placement: function (tooltip,element){
            var el = $(element);
            var bodyWidth = $(window).width();
            var elLeft = el.offset().left;
            var elWidth = el.outerWidth(true);
            var elTotalWidth = elLeft + elWidth + 100;
            if((elWidth < 200) && (bodyWidth <= elTotalWidth)) {
                return 'right auto';
            } else {
                return 'auto';
            }
        }
    }).on('show.bs.tooltip', function () {
        $('.tooltip').not('.slider .tooltip').remove();
    });

    $('body').on('mouseenter click mouseleave', '[data-helper]', function(e){
        var elem = $(this);
        var pop = $('[data-isshow]');
        var isShow = elem.data('isshow');

        if (pop.length && (e.type == 'click' || e.type == 'mouseenter') && pop[0] != elem[0]) {
            pop.removeAttr('data-isshow')
                .popover('hide')
                .data('isshow', false);
            $('body').off('.helperbodyevent');
        }

        if (!isShow) {
            elem.popover({
               template: $.ezdia.template.get('base-form-field-helper-popover')(),
               container: 'body',
               trigger: 'manual',
               html: true,
                placement: function (tooltip, element){
                    var el = $(element);
                    var bodyWidth = $(window).width();
                    var elLeft = el.offset().left;
                    var elWidth = el.outerWidth(true);
                    var elTotalWidth = elLeft + elWidth + 100;
                    if((elWidth < 200) && (bodyWidth <= elTotalWidth)) {
                        return 'left auto';
                    } else {
                        return 'right auto';
                    }
                }
           });

           if(e.type == 'mouseenter') {
               elem.popover('show');
           } else if (e.type == 'click'){
                elem.popover('show')
                    .attr('data-isshow', true)
                    .data('isshow', true);
                $('body').on('click.helperbodyevent', function(e){
                    var currElem = $(e.currentTarget);
                    var popover = currElem.data('helper');

                    if(!popover) {
                        var pop = $('[data-isshow]');
                        pop.removeAttr('data-isshow')
                            .popover('hide')
                            .data('isshow', false);

                        $('body').off('.helperbodyevent');
                    }

                });
           } else {
               elem.popover('hide');
           }
        } else if(e.type == 'click'){
            elem.removeAttr('data-isshow')
                .popover('hide')
                .data('isshow', false);
        }

    });

    // Click handler
    jQuery('#right-slider-toggle').on('click', function () {

        // State checker
        if( jQuery('.animated-wrapper').attr('data-state') === 'neutral' ) {
            jQuery('.animated-wrapper').attr('data-state', 'slide-left');
        } else {
            jQuery('.animated-wrapper').attr('data-state', 'neutral');
        }
    });

});


